/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RoleListVm,
    RoleListVmFromJSON,
    RoleListVmFromJSONTyped,
    RoleListVmToJSON,
    SimpleUserForUserRoleRelationVmPaginatedSearchResponse,
    SimpleUserForUserRoleRelationVmPaginatedSearchResponseFromJSON,
    SimpleUserForUserRoleRelationVmPaginatedSearchResponseFromJSONTyped,
    SimpleUserForUserRoleRelationVmPaginatedSearchResponseToJSON,
    UserRoleRelationVm,
    UserRoleRelationVmFromJSON,
    UserRoleRelationVmFromJSONTyped,
    UserRoleRelationVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserRoleRelationsVm
 */
export interface UserRoleRelationsVm {
    /**
     * 
     * @type {SimpleUserForUserRoleRelationVmPaginatedSearchResponse}
     * @memberof UserRoleRelationsVm
     */
    users?: SimpleUserForUserRoleRelationVmPaginatedSearchResponse;
    /**
     * 
     * @type {Array<RoleListVm>}
     * @memberof UserRoleRelationsVm
     */
    roles?: Array<RoleListVm> | null;
    /**
     * 
     * @type {Array<UserRoleRelationVm>}
     * @memberof UserRoleRelationsVm
     */
    userRoleRelations?: Array<UserRoleRelationVm> | null;
}

export function UserRoleRelationsVmFromJSON(json: any): UserRoleRelationsVm {
    return UserRoleRelationsVmFromJSONTyped(json, false);
}

export function UserRoleRelationsVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRoleRelationsVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': !exists(json, 'users') ? undefined : SimpleUserForUserRoleRelationVmPaginatedSearchResponseFromJSON(json['users']),
        'roles': !exists(json, 'roles') ? undefined : (json['roles'] === null ? null : (json['roles'] as Array<any>).map(RoleListVmFromJSON)),
        'userRoleRelations': !exists(json, 'userRoleRelations') ? undefined : (json['userRoleRelations'] === null ? null : (json['userRoleRelations'] as Array<any>).map(UserRoleRelationVmFromJSON)),
    };
}

export function UserRoleRelationsVmToJSON(value?: UserRoleRelationsVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': SimpleUserForUserRoleRelationVmPaginatedSearchResponseToJSON(value.users),
        'roles': value.roles === undefined ? undefined : (value.roles === null ? null : (value.roles as Array<any>).map(RoleListVmToJSON)),
        'userRoleRelations': value.userRoleRelations === undefined ? undefined : (value.userRoleRelations === null ? null : (value.userRoleRelations as Array<any>).map(UserRoleRelationVmToJSON)),
    };
}


